import {
    Button, Typography, IconButton, Toolbar, Popper, Grow, Paper, ClickAwayListener, MenuList, MenuItem
} from "@mui/material";
import { Close, ArrowDropDown as ArrowDropDownIcon } from "@mui/icons-material";

export const FormToolbar = ({
    editData,
    title,
    selectedSaveIndex,
    saveOptions,
    handleSaveToggle,
    handleSaveOptionsClose,
    handleSaveMenuItemClick,
    openSaveOptions,
    saveAnchorRef,
    handleUpdate,
    handleDelete,
    handleClose,
    dirty,
    setAuditOpen,
    auditIcon,
    onClose
}) => {
    return (
        <Toolbar sx={{ backgroundColor: "#F8F9FA", minHeight: '37px !important', gap: 1 }}>
            <Typography sx={{ flex: 1, color: "#2782EC", p: 0 }} component="div" fontWeight={600} fontSize={"16px"}>
                <span title={title}>{title}</span>
            </Typography>

            {!editData && saveOptions && (
                <span title={saveOptions[selectedSaveIndex]}>
                    <Button
                        ref={saveAnchorRef}
                        size="small"
                        variant="contained"
                        disableElevation
                        onClick={(event) => {
                            if (saveOptions.length === 1) {
                                handleSaveMenuItemClick(event, selectedSaveIndex);
                            } else {
                                handleSaveToggle(event);
                            }
                        }}
                        endIcon={saveOptions.length > 1 ? <ArrowDropDownIcon /> : null}
                        sx={{
                            backgroundColor: "white",
                            color: "green",
                            fontSize: "11px",
                            fontWeight: 600,
                            border: "1px solid black",
                            "&:hover": {
                                backgroundColor: "green",
                                color: "white",
                            }
                        }}
                    >
                        {saveOptions[selectedSaveIndex] === "Save & New" ? (
                            <span>Save{" & "}<u>N</u>ew</span>
                        ) : (
                            <span><u>S</u>ave{" & "}Close</span>
                        )}
                    </Button>
                </span>
            )}

            {editData && (
                <>
                    <span title="Audit Log">
                        <IconButton title="Audit Log" size="small" sx={{ mr: 1, gap: 1 }} onClick={() => setAuditOpen(true)}>
                            <img src={auditIcon} alt="Audit Log" width={20} height={20} />
                        </IconButton>
                    </span>
                    <span title="Update">
                        <Button
                            type="button"
                            size="small" disableRipple disableElevation sx={{ fontSize: "11px", px: 1, mr: 1, backgroundColor: "white", color: "green", border: "1px solid green", "&:hover": { backgroundColor: "green", color: "white" } }}
                            onClick={handleUpdate}
                        >
                            <><span style={{ textDecoration: "underline" }}>U</span>pdate</>
                        </Button>
                    </span>
                    <span title="Delete">
                        <Button
                            type="button"
                            size="small" disableRipple disableElevation
                            sx={{ fontSize: "11px", px: 1, mr: 1, backgroundColor: "white", color: "red", border: "1px solid red", "&:hover": { backgroundColor: "red", color: "white" } }}
                            onClick={handleDelete}
                        >
                            <>De<span style={{ textDecoration: "underline" }}>l</span>ete</>
                        </Button>
                    </span>
                </>
            )}

            {!editData && saveOptions && saveOptions.length > 1 && (
                <Popper
                    sx={{
                        zIndex: 1, backgroundColor: "white",
                        color: "green",
                        fontSize: "11px",
                        fontWeight: 600,
                    }}
                    open={openSaveOptions}
                    anchorEl={saveAnchorRef.current}
                    role={undefined}
                    transition
                    disablePortal
                >
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{
                                transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                            }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={handleSaveOptionsClose}>
                                    <MenuList id="split-button-menu" autoFocusItem>
                                        {saveOptions.map((option, index) => (
                                            <MenuItem
                                                key={option}
                                                selected={index === selectedSaveIndex}
                                                onClick={(event) => {
                                                    event.preventDefault();
                                                    handleSaveMenuItemClick(event, index);
                                                }}
                                                sx={{ fontSize: "11px", color: "green", fontWeight: 600 }}
                                                title={option}
                                            >
                                                {option === "Save & New" ? (
                                                    <span title="Save & New">Save{" & "}<u>N</u>ew</span>
                                                ) : (
                                                    <span title="Save & Close"><u>S</u>ave{" & "}Close</span>
                                                )}
                                            </MenuItem>
                                        ))}
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            )}

            <span title="Close">
                <IconButton
                    size="small"
                    edge="start"
                    onClick={() => handleClose(dirty || false)}
                    style={{ backgroundColor: "#686868", borderRadius: 2, width: 20, height: 20 }}
                    disableRipple
                >
                    <Close sx={{ color: "white", fontSize: "11px" }} />
                </IconButton>
            </span>
        </Toolbar>
    );
};
